import React from 'react'
import { Grid } from '@mui/material'
import type { GetCompanyByIdQuery } from '@edge/spark/io-dashboards'
import { CompanyAgentCard } from './CompanyAgentCard'
import { filterMaybe } from '@edge/spark/utils'
import { sortAgentNames } from '../../utils/sortAgentNames'

interface Props {
    accountId: number
    data: GetCompanyByIdQuery | undefined
    companyData?: GetCompanyByIdQuery | undefined
}

export const CompanyAgentCardsWidget: React.FC<Props> = ({ accountId, data, companyData }: Props) => {
    const agents = data?.auction?.accounts?.byId?.agents || {}
    const agentList = agents?.list?.filter(filterMaybe) || []

    return (
        <Grid container spacing={1} direction="column" justifyContent="space-evenly">
            {agentList.sort(sortAgentNames).map((agent, i) => {
                return agent ? (
                    <Grid item key={`${Math.random()}`}>
                        <CompanyAgentCard
                            companyData={companyData}
                            accountId={accountId}
                            agent={agent}
                            agents={agents}
                        />
                    </Grid>
                ) : null
            }) ?? []}
        </Grid>
    )
}

export default CompanyAgentCardsWidget
